/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PostView_home_Feeds$ref: FragmentReference;
declare export opaque type PostView_home_Feeds$fragmentType: PostView_home_Feeds$ref;
export type PostView_home_Feeds = {|
  +selectedPosts: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +title: string,
        +created: string,
        +found: string,
        +body: string,
        +body_short: string,
        +body_html: string,
        +link: ?string,
        +image_url: ?string,
        +source: {|
          +id: string,
          +name: ?string,
          +edited_name: ?string,
        |},
      |}
    |}>,
    +pageInfo: {|
      +hasNextPage: boolean,
      +endCursor: ?string,
    |},
  |},
  +$refType: PostView_home_Feeds$ref,
|};
export type PostView_home_Feeds$data = PostView_home_Feeds;
export type PostView_home_Feeds$key = {
  +$data?: PostView_home_Feeds$data,
  +$fragmentRefs: PostView_home_Feeds$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "allSubscriptions"
    },
    {
      "kind": "RootArgument",
      "name": "count"
    },
    {
      "kind": "RootArgument",
      "name": "filterTerms"
    },
    {
      "kind": "RootArgument",
      "name": "hasPhrase"
    },
    {
      "kind": "RootArgument",
      "name": "isAdvancedSearch"
    },
    {
      "kind": "RootArgument",
      "name": "orderBy"
    },
    {
      "kind": "RootArgument",
      "name": "searchScope"
    },
    {
      "kind": "RootArgument",
      "name": "searchTerms"
    },
    {
      "kind": "RootArgument",
      "name": "searchTime"
    },
    {
      "kind": "RootArgument",
      "name": "selectedSentimentPostIds"
    },
    {
      "kind": "RootArgument",
      "name": "source_In"
    },
    {
      "kind": "RootArgument",
      "name": "withWords"
    },
    {
      "kind": "RootArgument",
      "name": "withoutWords"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "after",
        "direction": "forward",
        "path": [
          "selectedPosts"
        ]
      }
    ]
  },
  "name": "PostView_home_Feeds",
  "selections": [
    {
      "alias": "selectedPosts",
      "args": [
        {
          "kind": "Variable",
          "name": "allSubscriptions",
          "variableName": "allSubscriptions"
        },
        {
          "kind": "Variable",
          "name": "filterTerms",
          "variableName": "filterTerms"
        },
        {
          "kind": "Variable",
          "name": "hasPhrase",
          "variableName": "hasPhrase"
        },
        {
          "kind": "Variable",
          "name": "isAdvancedSearch",
          "variableName": "isAdvancedSearch"
        },
        {
          "kind": "Variable",
          "name": "orderBy",
          "variableName": "orderBy"
        },
        {
          "kind": "Variable",
          "name": "searchScope",
          "variableName": "searchScope"
        },
        {
          "kind": "Variable",
          "name": "searchTerms",
          "variableName": "searchTerms"
        },
        {
          "kind": "Variable",
          "name": "searchTime",
          "variableName": "searchTime"
        },
        {
          "kind": "Variable",
          "name": "selectedSentimentPostIds",
          "variableName": "selectedSentimentPostIds"
        },
        {
          "kind": "Variable",
          "name": "source_In",
          "variableName": "source_In"
        },
        {
          "kind": "Variable",
          "name": "withWords",
          "variableName": "withWords"
        },
        {
          "kind": "Variable",
          "name": "withoutWords",
          "variableName": "withoutWords"
        }
      ],
      "concreteType": "PostNodeConnection",
      "kind": "LinkedField",
      "name": "__PostView_selectedPosts_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PostNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PostNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "created",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "found",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "body",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "body_short",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "body_html",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "link",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "image_url",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SourceNode",
                  "kind": "LinkedField",
                  "name": "source",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "edited_name",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '13a23de1fd5ad16759fc552def4e78b0';

module.exports = node;
